import type { FC } from 'react'
import styled from '@emotion/styled'

import Media from '@segment/matcha/components/Media'

import DesktopNavigation from './DesktopNavigation'
import MobileNavigation from './MobileNavigation'

const copy = {
  buttonText: `Log in`,
  buttonLink: `/login`,
}

const Navigation: FC = () => {
  return (
    <>
      <Media greaterThanOrEqual="md">
        <DesktopNavigation {...copy} />
      </Media>
      <Media lessThan="md">
        <MobileNavigation {...copy} />
      </Media>
    </>
  )
}

interface NavAsideProps {
  hideOnMobile: boolean
}
export const NavAside = styled.div<NavAsideProps>`
  display: grid;
  gap: 24px;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    display: ${({ hideOnMobile }) => (hideOnMobile ? `none` : `grid`)};
  }
`

export default Navigation
